import { Button, Flex, Form, Input, message } from 'antd'
import { useState } from 'react'
import { Api } from '~/core/trpc'
import { ErrorMessage } from '../../components/ErrorMessage'

type FormValues = {
  password: string
  passwordNew: string
  passwordNewConfirmation: string
}

export const FeatureResetPassword = () => {
  const resetPasswordMutation =
    Api.authentication.resetPasswordOnline.useMutation()

  const [errorKey, setErrorKey] = useState<string>()
  const [form] = Form.useForm<FormValues>()

  const isLoading = false

  const handleSubmit = async (values: FormValues) => {
    if (resetPasswordMutation.isLoading) {
      return
    }

    const isPasswordConfirmationOk =
      values.passwordNew === values.passwordNewConfirmation

    if (!isPasswordConfirmationOk) {
      setErrorKey(`bad-password-confirmation`)
      return
    }

    try {
      const { error } = await resetPasswordMutation.mutateAsync(values)

      if (error) {
        setErrorKey(error)
        return
      }

      message.success(`Password updated`)

      setErrorKey(null)
      form.resetFields()
    } catch (error) {
      setErrorKey('unknown')
    }
  }

  return (
    <>
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        requiredMark={false}
        style={{ width: '100%', maxWidth: '300px' }}
      >
        <Form.Item
          name="password"
          label="Current password"
          rules={[{ required: true, message: 'Current password is required' }]}
        >
          <Input.Password minLength={6} />
        </Form.Item>

        <Form.Item
          name="passwordNew"
          label="New password"
          rules={[{ required: true, message: 'New password is required' }]}
        >
          <Input.Password minLength={6} />
        </Form.Item>

        <Form.Item
          name="passwordNewConfirmation"
          label="New password confirmation"
          rules={[
            {
              required: true,
              message: 'New password confirmation is required',
            },
          ]}
        >
          <Input.Password minLength={6} />
        </Form.Item>

        <Form.Item>
          <Flex justify="end">
            <Button type="primary" htmlType="submit" loading={isLoading}>
              Save
            </Button>
          </Flex>
        </Form.Item>
      </Form>

      <ErrorMessage errorKey={errorKey} />
    </>
  )
}
